import React from 'react';
import { Modal, Form, Input, Select } from 'antd';

const { Option } = Select;

const AddDatabaseModal = ({ visible, onCancel, onAdd }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        console.log('Received values from form: ', values);
        // 发送请求到后端
        fetch(`//dai.caihuiltd.com/api/add-baseList`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          body: JSON.stringify(values),
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            console.log('Success:', data);
            onAdd()
          })

          .catch(error => {
            console.error('Error updating database:', error);
          });
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      title="Add Database"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save changes"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Select database type" name="type">
          <Select placeholder="MySQL">
            <Option value="mysql">MySQL</Option>
            <Option value="oracle">Oracle</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Select data source" name="host">
          <Input placeholder="localhost" />
        </Form.Item>
        <Form.Item label="Port number" name="port">
          <Input placeholder="3306" />
        </Form.Item>
        <Form.Item label="username" name="username">
          <Input placeholder="root" />
        </Form.Item>
        <Form.Item label="password" name="password">
          <Input placeholder="******" />
        </Form.Item>
        <Form.Item label="database_name" name="database_name">
          <Input placeholder="XXXXX" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDatabaseModal;